import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { softwareClassicProformaIssueFormsDirectRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/softwareClassicProformaIssueFormsDirectRoute.tsx';
import { classicSoftwareProjectLayoutNoOnboarding } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import ProformaIssueFormsDirect, {
	LazyProformaIssueFormsDirect,
} from './ui/proforma/issue-forms-direct/index-old.tsx';
import { proformaIssueFormsDirectPageEntryPoint } from './ui/proforma/issue-forms-direct/index.tsx';

export const softwareClassicProformaIssueFormsDirectRouteEntry = createEntry(
	softwareClassicProformaIssueFormsDirectRoute,
	() => ({
		group: 'classic-software',
		// TODO: remove this when cleaning up migrate-proforma-issue-forms-to-entry-points fg
		component: ProformaIssueFormsDirect,
		layout: classicSoftwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MENU_ID.PROJECTS,
		},

		resources: [projectContextResource],
		// TODO: remove this when cleaning up migrate-proforma-issue-forms-to-entry-points fg
		forPaint: [LazyAtlassianNavigation, LazyProformaIssueFormsDirect],
		entryPoint: () =>
			fg('migrate-proforma-issue-forms-to-entry-points')
				? proformaIssueFormsDirectPageEntryPoint
				: undefined,
		perfMetricKey: 'issue-forms-direct',
	}),
);
